import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ptBR from "./locales/pt-BR.json";

// Decisão de produto (H2.1 — opção C): o app é estritamente pt-BR.
// Mantemos o react-i18next como camada de strings (facilita refactor futuro
// e centraliza copy), mas SEM detector de idioma e SEM bundle do inglês —
// reduz JS no client e elimina drift de chaves entre locales.
i18n.use(initReactI18next).init({
  resources: {
    "pt-BR": { translation: ptBR },
  },
  lng: "pt-BR",
  fallbackLng: "pt-BR",
  supportedLngs: ["pt-BR"],
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = "pt-BR";
}

export default i18n;
